module.exports = __webpack_public_path__ + "static/media/info_background.2324c052.jpg";